export default function PlaceHolder(props) {
  return (
    <div className='flex flex-1 w-full'>
      <h1 className='text-center align-middle place-content-center content-center mx-auto my-auto font-bold text-lg text-gray-200 place-self-center'>
        {props.text}
      </h1>
    </div>
  );
}
